// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { alertMessageScreenHandler } from '@shared/utils/AppHandlers';
import { KeyEventProcessor } from '@shared/commons/KeyEventProcessor';
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { TerceraMessageBox } from './TerceraMessageBox';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
export class AlertMessageBox extends TerceraMessageBox {
    constructor() {
        super();
    }
    getType() {
        return ScreensNames.AlertMessageBox;
    }
    oninit() {
        super.oninit();
        this.observe('messageBoxType', (newValue) => {
            const iconSvg = 'alerts';
            let infoCustomCss = '';
            switch (newValue) {
                case AlertMessageBoxType.HIGH:
                    infoCustomCss = 'high-alert-info-tool';
                    break;
                case AlertMessageBoxType.MEDIUM:
                    infoCustomCss = 'medium-alert-info-tool';
                    break;
                case AlertMessageBoxType.LOW:
                    infoCustomCss = 'low-alert-info-tool';
                    break;
            }
            void this.set({ iconSvg, infoCustomCss });
        });
    }
    static Show(headerText, bodyText, type) {
        const alertMessageBox = new AlertMessageBox();
        void alertMessageBox.set({
            header: headerText,
            messageBoxText: bodyText,
            messageBoxType: type
        });
        MainWindowManager.AddControl(alertMessageBox);
        alertMessageBox.setFocus();
        const keyProc = KeyEventProcessor;
        keyProc.OnKeyDown.Subscribe(alertMessageBox.onGlobalKeyDown, alertMessageBox);
        return alertMessageBox;
    }
    static alertMessageScreenHandlerInitialize() {
        alertMessageScreenHandler.Show = AlertMessageBox.Show;
    }
}
export var AlertMessageBoxType;
(function (AlertMessageBoxType) {
    AlertMessageBoxType[AlertMessageBoxType["HIGH"] = 1] = "HIGH";
    AlertMessageBoxType[AlertMessageBoxType["MEDIUM"] = 5] = "MEDIUM";
    AlertMessageBoxType[AlertMessageBoxType["LOW"] = 10] = "LOW";
})(AlertMessageBoxType || (AlertMessageBoxType = {}));
TerceraMessageBox.extendWith(AlertMessageBox, {
    data: function () {
        return {
            hideCancel: true,
            style_addition_header: 'alert-message-box' /* overriding default value from super class #126487 */,
            okText: Resources.getResource('general.messageBox.ok')
        };
    }
});
